const printGenericDocument = require('./printableDocuments/printableGenericDocument/printableGenericDocument')

module.exports = {
    printGenericDocument,
}
